import { CollectiblesManager } from '@/components/collectibles/CollectiblesManager';
import { isStructureEditable as isEventStructureEditable } from '@/components/events/eventLifecycle';
import { useEventContext } from '@/pages/events/useEventContext';
import { Skeleton } from '@startupquickstart/frontend';

/**
 * Event Collectibles tab — thin wrapper around the shared owner-scoped
 * CollectiblesManager (also used by TemplateCollectiblesTab). With
 * `keyPrefix='Event'` and `apiBase=/events/:id` the manager's query keys
 * and endpoints are byte-identical to this tab's original inline
 * implementation.
 */
export function EventCollectiblesTab() {
  const { event, isLoading } = useEventContext();

  if (isLoading || !event) {
    return (
      <div className="space-y-4">
        <Skeleton className="h-32 rounded-xl" />
        <Skeleton className="h-32 rounded-xl" />
      </div>
    );
  }

  return (
    <CollectiblesManager
      ownerId={event.id}
      apiBase={`/events/${event.id}`}
      keyPrefix="Event"
      structureEditable={isEventStructureEditable(event.status)}
    />
  );
}
